import { Button } from "@/atoms-react/button/Button.react";
import { Modal, ModalContent } from "@/atoms-react/modal/index.react";
import { Themes } from "@/types/theme";
import { TrashIcon } from "@heroicons/react/20/solid";
import type React from "react";
import { useTranslation } from "react-i18next";

type ModalDeleteAliasProps = {
  isOpen: boolean;
  title?: string;
  onClose: () => void;
  onValidated: () => void;
  showTrashIcon?: boolean;
  isConfirmLoading?: boolean;
  disabled?: boolean;
  buttonCancelLabel?: string;
} & React.ComponentPropsWithoutRef<"div">;

export const ModalDeleteAlias = ({
  title = "",
  isOpen,
  onClose,
  onValidated,
  children,
  showTrashIcon = true,
  isConfirmLoading = false,
  disabled = false,
  buttonCancelLabel
}: ModalDeleteAliasProps) => {
  const { t } = useTranslation(["pass"]);
  return (
    <Modal open={isOpen} onClose={onClose} className="w-full max-w-2xl sm:w-full">
      <ModalContent title={title}>
        <div className="mt-4 flex flex-col gap-4">
          {children}
          <div className="mt-4 flex justify-end gap-4">
            <Button onClick={onClose} theme={Themes.white} className="w-max">
              {t("olkypass.general.cancel")}
            </Button>
            <Button
              icon={showTrashIcon ? <TrashIcon /> : null}
              onClick={onValidated}
              className="w-max"
              theme={Themes.danger}
              disabled={disabled}
              loading={isConfirmLoading}
              dataCy={"button-confirm-delete-alias"}
            >
              {buttonCancelLabel ?? t("olkypass.general.confirm")}
            </Button>
          </div>
        </div>
      </ModalContent>
    </Modal>
  );
};
